import * as sanitizeHtml from 'sanitize-html/dist/sanitize-html';

export function isJson(str: string) {
    if (!str) { return false; }
    if (typeof str.trim !== 'function') { return false; }

    return /^[\],:{}\s]*$/.test(str.trim().replace(/\\["\\\/bfnrtu]/g, '@')
        .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
        .replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
}

export function isBool(obj: string) {
    return obj === 'true' ||
        obj === 'false';
}

export function isHtml(str: string) {
    return /<[a-z][\s\S]*>/i.test(str);
}

export function sanitize(html: string, options?: sanitizeHtml.IOptions) {
    const defaults = options || {
        allowedTags: [
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p',
            'i', 'strong', 'strike', 'br',
            'div', 'span',
            'a',
            'img',
            'style',
        ],
        allowedAttributes: {
            '*': ['style', 'class'],
            a: ['href', 'target'],
            img: ['src', 'width', 'height', 'alt'],
        },
        selfClosing: [
            'img', 'br',
        ],
        allowedSchemes: [
            'http', 'https', 'data',
        ],
        allowedSchemesAppliedToAttributes: [
            'src',
            'href',
        ],
        allowedIframeHostnames: [],
    } as sanitizeHtml.IOptions;
    return sanitizeHtml(html, defaults);
}
